// removed by extract-text-webpack-plugin
module.exports = {"slidecontainer":"_1XLQfVOs","slider":"_3cExzkXI","questAnswer":"_1CVmaVmL"};